<template>
    <div class="row">
        <div class="col-12">
        </div>
        <div class="col-12">
            <h1>{{ zona.sector }}</h1>
        </div>
        <div class="col-12">
            <p>{{ $t('nuevo_abono.selector_zona') }}</p>
            <div class="form-group" v-if="zonas">
                <multiselect
                    v-model="new_zona"
                    :placeholder="$t('nuevo_abono.seleccionar_zona')"
                    label="name"
                    track-by="code"
                    :options="zonas"
                />
            </div>
        </div>
        <div class="col-12">
            <p>Componente eliminado</p>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['zona', 'zonas'],
        data() {
            return {
                loading: true,
                new_zona: null
            }
        },
        watch: {
            new_zona() {
                if(this.new_zona != null) {
                    this.$emit('changeZona', this.new_zona);
                    this.new_zona = null;
                }
            }
        },
        methods: {
            cambiarZona(zona) {
                this.$emit('cambiarZona', zona);
            }
        }
    }
</script>
